import { AnoNe, CsEnNazev, CsEnPopis } from "b2b/renderers";

export const id = () => ({
  id: "id",
  label: "b2b.produkty-grid-columns.id.label",
  path: "id"
});
export const nazev = () => ({
  id: "nazev",
  label: "b2b.produkty-grid-columns.nazev.label",
  path: "",
  renderer: CsEnNazev
});
export const popis = () => ({
  id: "popis",
  label: "b2b.produkty-grid-columns.popis.label",
  path: "",
  renderer: CsEnPopis
});
export const zkratka = () => ({
  id: "zkratka",
  label: "b2b.produkty-grid-columns.zkratka.label",
  path: "zkratka"
});
export const uzivaNapajeni = () => ({
  id: "uzivaNapajeni",
  label: "b2b.produkty-grid-columns.uzivaNapajeni.label",
  path: "uzivaNapajeni",
  renderer: AnoNe
});
export const vylucny = () => ({
  id: "vylucny",
  label: "b2b.produkty-grid-columns.vylucny.label",
  path: "vylucny",
  renderer: AnoNe
});
export const parkovani = () => ({
  id: "parkovani",
  label: "b2b.produkty-grid-columns.parkovani.label",
  path: "parkovani",
  renderer: AnoNe
});
export const bezCasu = () => ({
  id: "bezCasu",
  label: "b2b.produkty-grid-columns.bezCasu.label",
  path: "bezCasu",
  renderer: AnoNe
});
